import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import { connect } from "react-redux";
import { Apply_Promo } from "../../store/actions";
import instance from "../../store/actions/instance";
import StorefrontActionButton from "../../Components/Storefront/ActionButton/StorefrontActionButton";

export const getPromotionCodeError = (error, language = "english") => {
  const arabic = language === "arabic";
  const data = error?.response?.data || {};
  if (data.error === "expired")
    return arabic
      ? data.expired_message_ar || "انتهت صلاحية هذا الرمز."
      : data.expired_message || "This code has expired.";
  if (data.error === "minimum" || data.error === "below_minimum")
    return arabic
      ? "لم تصل السلة إلى الحد الأدنى لهذا الرمز بعد."
      : "Your cart has not reached this code’s minimum yet.";
  return arabic
    ? "هذا الرمز غير صالح لهذا الطلب."
    : "This code isn’t valid for this order.";
};

export class CartPromotionCode extends Component {
  state = { code: "", error: "", expanded: false, loading: false };

  apply = async () => {
    const code = this.state.code.trim();
    if (!code || this.state.loading) return;
    this.setState({ loading: true, error: "" });
    try {
      const response = await instance.post("coupon/", {
        code,
        branch: this.props.branch?.branch || null,
        country_code: this.props.currency?.selected,
        channel: this.props.channel,
      });
      this.props.applyPromo(response.data);
      this.setState({ loading: false, expanded: false, code: "" });
    } catch (error) {
      this.setState({
        loading: false,
        error: getPromotionCodeError(error, this.props.language),
      });
    }
  };

  render() {
    const arabic = this.props.language === "arabic";
    const promo = this.props.promo;
    return (
      <section className="checkout-v2-cart-promo">
        <button
          aria-expanded={this.state.expanded}
          className="checkout-v2-cart-promo__toggle"
          onClick={() =>
            this.setState((state) => ({
              expanded: !state.expanded,
              error: "",
            }))
          }
          type="button"
        >
          <LocalOfferOutlinedIcon />
          <span>
            <strong>
              {promo
                ? arabic
                  ? `تم تطبيق ${promo.code || promo.name || "العرض"}`
                  : `${promo.code || promo.name || "Promotion"} applied`
                : arabic
                  ? "هل لديك رمز ترويجي؟"
                  : "Have a promo code?"}
            </strong>
          </span>
          <ExpandMoreRoundedIcon
            className={this.state.expanded ? "is-expanded" : ""}
          />
        </button>
        {this.state.expanded && (
          <div className="checkout-v2-cart-promo__body">
            {promo ? (
              <div className="checkout-v2-cart-promo__applied">
                <span>{promo.code || promo.name || "Promotion"}</span>
                <button onClick={() => this.props.applyPromo()} type="button">
                  {arabic ? "إزالة" : "Remove"}
                </button>
              </div>
            ) : (
              <>
                <div className="checkout-v2-cart-promo__form">
                  <input
                    aria-label={arabic ? "رمز العرض" : "Promotion code"}
                    autoCapitalize="characters"
                    onChange={(event) =>
                      this.setState({ code: event.target.value, error: "" })
                    }
                    onKeyDown={(event) => {
                      if (event.key === "Enter") this.apply();
                    }}
                    placeholder={arabic ? "أدخل الرمز" : "Enter code"}
                    value={this.state.code}
                  />
                  <StorefrontActionButton
                    disabled={!this.state.code.trim() || this.state.loading}
                    onClick={this.apply}
                  >
                    {this.state.loading ? (
                      <CircularProgress size={17} />
                    ) : arabic ? (
                      "تطبيق"
                    ) : (
                      "Apply"
                    )}
                  </StorefrontActionButton>
                </div>
                {!!this.state.error && (
                  <p className="checkout-v2-cart-promo__error" role="alert">
                    {this.state.error}
                  </p>
                )}
              </>
            )}
          </div>
        )}
      </section>
    );
  }
}

export default connect(
  (state) => ({
    branch: state.branch,
    channel: state.promise?.src,
    currency: state.currency,
    language: state.store?.language || "english",
    promo: state.cart?.promos,
  }),
  (dispatch) => ({ applyPromo: (promo) => dispatch(Apply_Promo(promo)) }),
)(CartPromotionCode);
